import { jsx } from 'react/jsx-runtime';

const NumberedListItem = ({ className, children })=>{
    return jsx("li", {
        className: className,
        children: children
    });
};
NumberedListItem.displayName = 'NumberedList.Item';

export { NumberedListItem };
//# sourceMappingURL=NumberedList.Item.es.js.map
